var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "version-history"
  }, [_vm._m(0), !_vm.history.length ? _c('div', {
    staticClass: "history-empty"
  }, [_vm._v(" Ainda não há versões para este modelo. ")]) : _vm._e(), _vm._l(_vm.history, function (version) {
    return _c('div', {
      key: version.id,
      staticClass: "history-row"
    }, [_c('div', {
      staticClass: "history-line"
    }, [_c('span', {
      class: ['history-dot', _vm.statusClass(version)]
    }, [_c('i')])]), _c('div', {
      staticClass: "history-content"
    }, [_c('div', {
      staticClass: "d-flex align-items-start justify-content-between"
    }, [_c('div', [_c('div', {
      staticClass: "d-flex align-items-center flex-wrap"
    }, [_c('strong', [_vm._v("Versão " + _vm._s(version.numero))]), _c('span', {
      class: ['badge ml-2', _vm.badgeClass(version)]
    }, [_vm._v(_vm._s(_vm.statusLabel(version)))])]), _c('small', [_vm._v(_vm._s(_vm.dateLabel(version)))])]), _vm.canRestore(version) ? _c('button', {
      staticClass: "btn btn-xs btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('restore', version);
        }
      }
    }, [_vm._v(" Restaurar ")]) : _vm._e()]), version.observacao ? _c('p', [_vm._v(_vm._s(version.observacao))]) : _vm._e(), version.id_versao_origem ? _c('span', {
      staticClass: "origin-note"
    }, [_vm._v(" Criada a partir da versão " + _vm._s(_vm.sourceNumber(version.id_versao_origem)) + " ")]) : _vm._e()])]);
  }), _vm.origin === 'legado' && _vm.hasPublication ? _c('div', {
    staticClass: "legacy-return"
  }, [_vm._m(1), _c('button', {
    staticClass: "btn btn-sm btn-outline-danger font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('reactivate-legacy');
      }
    }
  }, [_vm._v(" Reativar legado ")])]) : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "history-safety"
  }, [_c('i', {
    staticClass: "fas fa-shield-alt"
  }), _c('div', [_c('strong', [_vm._v("Você sempre pode voltar")]), _c('span', [_vm._v("Publicar cria uma nova versão e mantém as anteriores disponíveis.")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('strong', [_vm._v("Voltar para a etiqueta original")]), _c('span', [_vm._v("Desativa a versão do editor e reativa imediatamente o motor legado protegido.")])]);
}];
export { render, staticRenderFns };